import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import SessionContext from 'contexts/session';
import PageLoader from 'components/PageLoader';

type Props = {
  replace?: boolean;
};

const RoleBasedHomeRedirect = ({ replace = true }: Props) => {
  const { user, userChecking } = useContext(SessionContext);

  if (userChecking) {
    return <PageLoader />;
  }

  const to = user?.role === 'ADMIN' ? '/admin' : '/';

  return <Navigate to={to} replace={replace} />;
};

export default RoleBasedHomeRedirect;
